export default __webpack_public_path__ + "static/media/karaoke-night.570cfd12.svg";